var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticStyle:{"min-height":"100%"},attrs:{"color":"primary"}},[_c('v-container',[_c('router-view',{ref:"component"}),_c('check-version',{on:{"entendido":_vm.onAceptarAdvertenciaVersion}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }